module.exports = __webpack_public_path__ + "static/media/SZ.bb49a013.svg";